import './SingleValue.css';
export var container = '_1n8ar1o0-2-0-1';